import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-loading-dialog',
  templateUrl: './loading-dialog.component.html',
  styleUrls: ['./loading-dialog.component.css']
})
export class LoadingDialogComponent implements OnInit {

  message = "Loading...";

  constructor(public dialogRef: MatDialogRef<LoadingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

      this.dialogRef.disableClose = true;
      this.message = data.msg;
    }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/utilities/Dialog/dialog/loading-dialog/loading-dialog.component.ts